import React from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faPen } from '@fortawesome/free-solid-svg-icons';
import './RequiredDocumentTypes.scss';

interface RequiredDocumentTypesProps {
    requiredDocumentTypes: string[];
    lastEditedByName?: string;
    lastEditedAt?: string;
    canEdit: boolean;
    onEdit: () => void;
}

export const RequiredDocumentTypes = (props: RequiredDocumentTypesProps) => {
    return (
        <div className="required-document-types">
            <div className="required-document-types__header">
                <h4 className="required-document-types__title">
                    Document Types Required to Close
                </h4>
                {props.canEdit && (
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={props.onEdit}>
                        <FontAwesomeIcon icon={faPen} /> Edit List
                    </button>
                )}
            </div>
            <div className="required-document-types__chips">
                {props.requiredDocumentTypes.map((documentType) => (
                    <span
                        className="required-document-types__chip"
                        key={documentType}>
                        <FontAwesomeIcon
                            icon={faFile}
                            className="required-document-types__chip-icon"
                        />
                        {documentType}
                    </span>
                ))}
            </div>
            {props.lastEditedAt && (
                <p className="required-document-types__last-edited">
                    Last edited by {props.lastEditedByName} on{' '}
                    {moment.utc(props.lastEditedAt).local().format('M/D/YYYY')}
                </p>
            )}
        </div>
    );
};
